import React, { useState, ChangeEvent, FormEvent } from "react";
import { toast } from "react-toastify";

// Tipamos la respuesta que esperamos de nuestro backend de Node
interface UploadResponse {
  success: boolean;
  videoId?: string;
  url?: string;
  error?: string;
}

export default function UploadShort() {
  const [video, setVideo] = useState<File | null>(null);
  const [title, setTitle] = useState<string>("");
  const [description, setDescription] = useState<string>("");
  const [loading, setLoading] = useState<boolean>(false);
  const [shortUrl, setShortUrl] = useState<string>("");

  // Capturar el archivo binario del input
  const handleFileChange = (e: ChangeEvent<HTMLInputElement>) => {
    if (e.target.files && e.target.files.length > 0) {
      setVideo(e.target.files[0]);
    }
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!video) return alert("Please select a video first");

    setLoading(true);

    const BASE_URL =
      process.env.NODE_ENV === "development"
        ? "http://localhost:5500"
        : "https://ligavirtualf1.es:5500";

    // 1. Creamos el contenedor FormData
    const formData = new FormData();

    // 2. Metemos el archivo y los textos con las claves que espera tu backend
    formData.append("video", video); // Esto llegará a Node como req.files.video
    formData.append("title", title); // Esto llegará a Node como req.body.title
    formData.append("description", description); // Esto llegará a Node como req.body.description

    try {
      const response = await fetch(`${BASE_URL}/api/admin/upload-short`, {
        method: "POST",
        body: formData, // <-- Le pasamos el formData completo aquí
        // IMPORTANTE: Deja los headers vacíos. No pongas "Content-Type".
        // El navegador se encarga de configurarlo automáticamente.
      });

      const data = await response.json();

      if (data.success) {
        // ✅ Toast de éxito en inglés
        toast.success(
          "Short published successfully on YouTube and Instagram! 🚀",
        );

        // Opcional: limpiar el formulario tras el éxito
        setVideo(null);
        setTitle("");
        setDescription("");
      } else {
        // ❌ Toast de error devuelto por el servidor
        toast.error(`Error: ${data.error || "Failed to upload reels"}`);
      }
    } catch (error) {
      console.error("Error connecting to the server:", error);
      // ❌ Toast de error de conexión en inglés
      toast.error("An error occurred while connecting to the server.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      style={{
        padding: "20px",
        maxWidth: "400px",
        margin: "0 auto",
        fontFamily: "sans-serif",
      }}
    >
      <h2>Subir Short (TypeScript)</h2>
      <form onSubmit={handleSubmit}>
        <div style={{ marginBottom: "10px" }}>
          <label style={{ display: "block", fontWeight: "bold" }}>
            Título del Short:
          </label>
          <input
            type="text"
            value={title}
            onChange={(e: ChangeEvent<HTMLInputElement>) =>
              setTitle(e.target.value)
            }
            placeholder="Ej: Brutal adelantamiento en Spa #shorts"
            style={{
              width: "100%",
              padding: "8px",
              marginTop: "5px",
              boxSizing: "border-box",
            }}
          />
        </div>

        <div style={{ marginBottom: "10px" }}>
          <label style={{ display: "block", fontWeight: "bold" }}>
            Descripción:
          </label>
          <textarea
            value={description}
            onChange={(e: ChangeEvent<HTMLTextAreaElement>) =>
              setDescription(e.target.value)
            }
            placeholder="Detalles de la carrera..."
            style={{
              width: "100%",
              padding: "8px",
              marginTop: "5px",
              boxSizing: "border-box",
            }}
          />
        </div>

        <div style={{ marginBottom: "15px" }}>
          <label style={{ display: "block", fontWeight: "bold" }}>
            Video de la PC:
          </label>
          <input
            type="file"
            accept="video/*"
            onChange={handleFileChange}
            style={{ marginTop: "5px" }}
          />
        </div>

        <button
          type="submit"
          disabled={loading}
          style={{
            width: "100%",
            padding: "10px",
            backgroundColor: loading ? "#ccc" : "#ff0000",
            color: "white",
            border: "none",
            cursor: loading ? "not-allowed" : "pointer",
            fontWeight: "bold",
          }}
        >
          {loading ? "Transmitiendo binario..." : "Publicar Short"}
        </button>
      </form>

      {shortUrl && (
        <div
          style={{
            marginTop: "20px",
            color: "green",
            padding: "10px",
            border: "1px solid green",
            borderRadius: "4px",
          }}
        >
          <p style={{ margin: "0 0 5px 0" }}>🎉 ¡Subido correctamente!</p>
          <a
            href={shortUrl}
            target="_blank"
            rel="noreferrer"
            style={{ wordBreak: "break-all" }}
          >
            {shortUrl}
          </a>
        </div>
      )}
    </div>
  );
}
